import { Layout } from '../../components/front'
import { getProductCategories, getStaticDate } from '../../lib'

export async function getServerSideProps() {
    const productCategories = await getProductCategories()
    const data = await getStaticDate()
    return {
        props: {
            productCategories: productCategories,
            text: data['about_page'].content,
            footer: data['about_footer'].content
        }
    }
}

export default function About({ productCategories, text, footer }) {
    return (
        <Layout menu={productCategories} footer={{ about: footer }}>
            <div className="bg-gray-200 p-4">
                <div className="rounded bg-white w-full p-10">
                    <h1 className="text-center text-2xl">درباره ما</h1>
                    <p className="text-justify p-5" style={{ textAlignLast: 'center' }}>
                        <pre className="whitespace-pre-wrap" style={{ fontFamily: 'IRANSans' }}>
                            {text}
                        </pre>
                    </p>
                </div>
            </div>
        </Layout>
    )
}
